import { Partnership } from '@/models/partnership';

import { Event } from './event';

export class PartnershipsRetreivedEvent extends Event<Partnership[]> {}
